import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { UIProvider } from "@/context/UIContext";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BillUploadDialog } from "@/components/BillUploadDialog";
import { LeadDialog } from "@/components/LeadDialog";
import { ScrollToTop, WhatsAppFab } from "@/components/Utils";
import { ChatAssistant } from "@/components/ChatAssistant";

import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import Privatkunden from "@/pages/Privatkunden";
import Gewerbekunden from "@/pages/Gewerbekunden";
import UeberUns from "@/pages/UeberUns";
import Kontakt from "@/pages/Kontakt";
import Ratgeber from "@/pages/Ratgeber";
import FaqPage from "@/pages/FaqPage";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Standorte from "@/pages/Standorte";
import LocationPage from "@/pages/LocationPage";
import StandortHub from "@/pages/StandortHub";
import BranchenOverview from "@/pages/BranchenOverview";
import BranchePage from "@/pages/BranchePage";
import ArticlePage from "@/pages/ArticlePage";
import Gewerbestrom from "@/pages/Gewerbestrom";
import TopicPage from "@/pages/TopicPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Hausverwaltungen from "@/pages/Hausverwaltungen";

function AppBody() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isStandalone = isAdmin || pathname.startsWith("/hausverwaltungen");
  return (
    <>
      <ScrollToTop />
      {!isStandalone && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hausverwaltungen" element={<Hausverwaltungen />} />
          <Route path="/privatkunden" element={<Privatkunden />} />
          <Route path="/gewerbekunden" element={<Gewerbekunden />} />
          <Route path="/strom" element={<CategoryPage />} />
          <Route path="/gas" element={<CategoryPage />} />
          <Route path="/photovoltaik" element={<CategoryPage />} />
          <Route path="/waermepumpe" element={<CategoryPage />} />
          <Route path="/ratgeber" element={<Ratgeber />} />
          <Route path="/ratgeber/:slug" element={<ArticlePage />} />
          <Route path="/branchen" element={<BranchenOverview />} />
          <Route path="/branche/:branche" element={<BranchePage />} />
          <Route path="/gewerbestrom" element={<Gewerbestrom />} />
          <Route path="/tarife/:slug" element={<TopicPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/standorte" element={<Standorte />} />
          <Route path="/standorte/:slug" element={<StandortHub />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/:service/:city" element={<LocationPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isStandalone && <Footer />}
      <BillUploadDialog />
      <LeadDialog />
      {!isStandalone && <WhatsAppFab />}
      {!isStandalone && <ChatAssistant />}
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  useLenis();
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <UIProvider>
          <AppBody />
        </UIProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
